import React, { useRef } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Info } from 'lucide-react';

/**
 * FieldLabel / InfoDot — a form-field label with an optional "i" info
 * icon. The explanation lives in a hover/focus tooltip on the icon
 * rather than as a line of text under the input, keeping forms compact.
 *
 * Shared by the template editor and the guided template form. Relies
 * on the `tpl-label` / `tpl-info` / `tpl-tooltip` styles defined in
 * Settings/TemplateEditor.css (loaded wherever these are used).
 */

let _tipCounter = 0;

// InfoDot — the icon + tooltip on its own (e.g. for table headers).
export function InfoDot({ hint }) {
    const idRef = useRef(null);
    if (idRef.current === null) {
        _tipCounter += 1;
        idRef.current = `tpl-tip-${_tipCounter}`;
    }
    if (!hint) return null;
    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={idRef.current} className="tpl-tooltip">{hint}</Tooltip>}
        >
            <span className="tpl-info" tabIndex={0} role="button" aria-label="Mer information">
                <Info size={13} />
            </span>
        </OverlayTrigger>
    );
}

function FieldLabel({ text, hint }) {
    return (
        <label className="tpl-label">
            <span>{text}</span>
            <InfoDot hint={hint} />
        </label>
    );
}

export default FieldLabel;
